export default "__VITE_ASSET__CC015thF__"